import { render, staticRenderFns } from "./Skilling.vue?vue&type=template&id=dc30686a&"
import script from "./Skilling.vue?vue&type=script&lang=js&"
export * from "./Skilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports